// import { useContext, useEffect, useState } from "react";
// import PropTypes from "prop-types"; // Add this import
// import Grid from "@mui/material/Grid";
// import TextField from "@mui/material/TextField";
// import Autocomplete from "@mui/material/Autocomplete";
// import MDBox from "components/MDBox";
// import VehicleCard from "./vehicleCard";
// import { AccountsContext } from "context/AccountsContext";
// import axios from "axios";
// import { cachementreportendpoint } from "config";

// function VehicleList({ onJourneysChange }) {
//   const { fetchThings, things } = useContext(AccountsContext);
//   const [selectedVehicle, setSelectedVehicle] = useState(null);
//   const [journeys, setJourneys] = useState([]);
//   const [selectedJourneys, setSelectedJourneys] = useState({});

//   useEffect(() => {
//     fetchThings();
//   }, []);

//   // Fetch report API when vehicle is selected
//   const handleVehicleSelect = async (newValue) => {
//     setSelectedVehicle(newValue);
//     setJourneys([]);
//     setSelectedJourneys({});
//     if (!newValue) {
//       onJourneysChange([], {}); // Clear journeys in parent
//       return;
//     }

//     try {
//       const token = localStorage.getItem("token");
//       const response = await axios.get(
//         `${cachementreportendpoint}/${newValue.thingId}?thingId=${newValue.thingId}`,
//         {
//           headers: {
//             "x-dhundhoo-session": token,
//           },
//         }
//       );
//       console.log("API Response:", response.data);

//       if (response.data?.allWayPoints) {
//         setJourneys(response.data.allWayPoints);
//         onJourneysChange(response.data.allWayPoints, {}); // Pass journeys to parent
//       }
//     } catch (error) {
//       console.error("Error fetching vehicle report:", error);
//     }
//   };

//   // Toggle checkbox selection
//   const handleCheckboxChange = (journeyId) => {
//     setSelectedJourneys((prev) => {
//       const newSelectedJourneys = {
//         ...prev,
//         [journeyId]: !prev[journeyId],
//       };
//       onJourneysChange(journeys, newSelectedJourneys); // Pass updated journeys and selections
//       return newSelectedJourneys;
//     });
//   };

//   return (
//     <MDBox>
//       {/* Dropdown Search */}
//       <Grid container spacing={2} mb={2}>
//         <Grid item xs={12}>
//           <Autocomplete
//             disablePortal
//             options={things || []}
//             getOptionLabel={(option) => option.nickName || option.thingId}
//             value={selectedVehicle}
//             onChange={(event, newValue) => handleVehicleSelect(newValue)}
//             renderOption={(props, option) => (
//               <li
//                 {...props}
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   width: "100%",
//                 }}
//               >
//                 <span>{option.nickName}</span>
//                 <span style={{ color: "#666" }}>{option.thingId}</span>
//               </li>
//             )}
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 placeholder="Search or select vehicle"
//                 fullWidth
//                 size="small"
//               />
//             )}
//           />
//         </Grid>
//       </Grid>

//       {/* Show journeys with checkboxes */}
//       {selectedVehicle && (
//         <Grid container spacing={2}>
//           <Grid item xs={12}>
//             <VehicleCard
//               title={selectedVehicle.nickName || selectedVehicle.thingId}
//               journeys={journeys}
//               selectedJourneys={selectedJourneys}
//               onToggleJourney={handleCheckboxChange}
//               onDelete={() => setSelectedVehicle(null)}
//             />
//           </Grid>
//         </Grid>
//       )}
//     </MDBox>
//   );
// }

// VehicleList.propTypes = {
//   onJourneysChange: PropTypes.func.isRequired,
// };

// export default VehicleList;
import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MDBox from "components/MDBox";
import VehicleCard from "./vehicleCard";
import { AccountsContext } from "context/AccountsContext";
import axios from "axios";
import { cachementreportendpoint } from "config";
import Button from "@mui/material/Button";

function VehicleList({ onJourneysChange }) {
  const { fetchThings, things } = useContext(AccountsContext);
  const [selectedVehicles, setSelectedVehicles] = useState([]); // Array to track vehicles with their journeys
  const [selectedJourneys, setSelectedJourneys] = useState({}); // Combined selections
  const [showAddVehicle, setShowAddVehicle] = useState(false); // Toggle for additional vehicle dropdown

  useEffect(() => {
    fetchThings();
  }, []);

  // Fetch report API when a new vehicle is selected
  const handleVehicleSelect = async (newValue) => {
    if (!newValue) {
      setSelectedVehicles([]);
      setSelectedJourneys({});
      onJourneysChange([], {}); // Clear journeys in parent
      setShowAddVehicle(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${cachementreportendpoint}/${newValue.thingId}?thingId=${newValue.thingId}`,
        {
          headers: {
            "x-dhundhoo-session": token,
          },
        }
      );
      console.log("API Response:", response.data);

      if (response.data?.allWayPoints) {
        const newJourneys = response.data.allWayPoints;
        const updatedVehicles = [
          ...selectedVehicles,
          { ...newValue, journeys: newJourneys }, // Associate journeys with vehicle
        ];
        setSelectedVehicles(updatedVehicles);

        // Update selectedJourneys with new journey IDs
        const allSelectedJourneys = { ...selectedJourneys };
        newJourneys.forEach((journey) => {
          if (!allSelectedJourneys[journey.journeyId]) {
            allSelectedJourneys[journey.journeyId] = false; // Initialize as unselected
          }
        });

        setSelectedJourneys(allSelectedJourneys);
        onJourneysChange(
          updatedVehicles.flatMap((v) => v.journeys), // Combine all journeys for map
          allSelectedJourneys
        );
        setShowAddVehicle(true); // Show "Add Another Vehicle" button after selection
      }
    } catch (error) {
      console.error("Error fetching vehicle report:", error);
    }
  };

  // Toggle checkbox selection
  const handleCheckboxChange = (journeyId) => {
    setSelectedJourneys((prev) => {
      const newSelectedJourneys = {
        ...prev,
        [journeyId]: !prev[journeyId],
      };
      onJourneysChange(
        selectedVehicles.flatMap((v) => v.journeys), // Pass all journeys
        newSelectedJourneys
      );
      return newSelectedJourneys;
    });
  };

  // Remove a vehicle and its associated journeys
  const handleRemoveVehicle = (vehicleToRemove) => {
    const updatedVehicles = selectedVehicles.filter(
      (vehicle) => vehicle.thingId !== vehicleToRemove.thingId
    );
    const removedJourneyIds = vehicleToRemove.journeys.map((j) => j.journeyId);
    const updatedSelectedJourneys = { ...selectedJourneys };
    removedJourneyIds.forEach((id) => delete updatedSelectedJourneys[id]);

    setSelectedVehicles(updatedVehicles);
    setSelectedJourneys(updatedSelectedJourneys);
    onJourneysChange(
      updatedVehicles.flatMap((v) => v.journeys), // Pass remaining journeys
      updatedSelectedJourneys
    );

    if (updatedVehicles.length === 0) {
      setShowAddVehicle(false);
    }
  };

  return (
    <MDBox>
      {/* Dropdown Search for initial or additional vehicle */}
      {!showAddVehicle && (
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12}>
            <Autocomplete
              disablePortal
              options={things || []}
              getOptionLabel={(option) => option.nickName || option.thingId}
              value={null} // Reset value for new selection
              onChange={(event, newValue) => handleVehicleSelect(newValue)}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{option.nickName}</span>
                  <span style={{ color: "#666" }}>{option.thingId}</span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search or select vehicle"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>
        </Grid>
      )}

      {/* Show journeys with checkboxes for each selected vehicle */}
      {selectedVehicles.map((vehicle, index) => (
        <Grid container spacing={2} key={vehicle.thingId} mb={2}>
          <Grid item xs={12}>
            <VehicleCard
              title={vehicle.nickName || vehicle.thingId}
              journeys={vehicle.journeys} // Show only this vehicle's journeys
              selectedJourneys={selectedJourneys}
              onToggleJourney={handleCheckboxChange}
              onDelete={() => handleRemoveVehicle(vehicle)}
            />
          </Grid>
        </Grid>
      ))}

      {/* Add Another Vehicle Button and Dropdown */}
      {showAddVehicle && selectedVehicles.length > 0 && (
        <Grid container spacing={2} mb={2}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setShowAddVehicle(true)} // Keep dropdown visible
              sx={{ mt: 2, mb: 2 }}
            >
              Add Another Vehicle
            </Button>
            <Autocomplete
              disablePortal
              options={things.filter(
                (thing) => !selectedVehicles.some((v) => v.thingId === thing.thingId)
              )} // Exclude already selected vehicles
              getOptionLabel={(option) => option.nickName || option.thingId}
              value={null} // Reset value for new selection
              onChange={(event, newValue) => handleVehicleSelect(newValue)}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{option.nickName}</span>
                  <span style={{ color: "#666" }}>{option.thingId}</span>
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Search or select another vehicle"
                  fullWidth
                  size="small"
                  sx={{ mt: 2 }}
                />
              )}
            />
          </Grid>
        </Grid>
      )}
    </MDBox>
  );
}

VehicleList.propTypes = {
  onJourneysChange: PropTypes.func.isRequired,
};

export default VehicleList;